const $inject = [];

const lbLoadingPlaceholderItemCtrl = function () {
  let vm = this;

  vm.items = createItems(vm.total);
  vm.getItemWidth = getItemWidth;

  function createItems(totalItems = 1) {
    return _.map(_.times(totalItems), (item) => {
      return {
        width: getItemWidth(item),
      };
    });
  }

  function getItemWidth(itemIndex) {
    return vm.width ? vm.width : itemIndex === 0 ? '100%' : randomWidth();
  }

  function randomWidth() {
    return _.random(85, 100) + '%';
  }
};

lbLoadingPlaceholderItemCtrl.$inject = $inject;

export default lbLoadingPlaceholderItemCtrl;



// WEBPACK FOOTER //
// ./src/components/lbLoadingPlaceholder/lbLoadingPlaceholderItemCtrl.js